<template>
  <VModal :showing="showing" container-classes="max-w-screen-sm" @update:showing="$emit('cancel')">
    <div class="flex items-start mb-6">
      <span class="flex-shrink-0 w-10 h-10 mr-4 rounded-full bg-gold-100 grid place-items-center">
        <ExclamationTriangleIcon class="inline h-6 text-gold-50" />
      </span>
      <div><h2 class="mt-2 mb-4 mr-8 text-xl">You have unsaved changes.</h2></div>
    </div>
    <div class="flex justify-center">
      <div>
        <VButton class="mr-2" variant="dark" size="sm" @click="$emit('cancel')">Continue editing</VButton>
        <VButton size="sm" @click="$emit('leave')">Leave without saving</VButton>
      </div>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

defineProps({
  showing: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['leave', 'cancel'])
</script>
